import * as Sentry from '@sentry/browser';
import '../sass/project.scss';
import './post_sidenav_state.js';

/* Sentry Error Reporting */
const sentryConfigElement = document.getElementById('sentry-config');
if (sentryConfigElement) {
  const config = JSON.parse(sentryConfigElement.textContent);
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release.replace(/^v/, ''),
    tracesSampleRate: parseFloat(config.tracesSampleRate),
    tunnel: config.tunnel,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const dataProfileElement = document.getElementById('data-profile');
  // checks if the data profile icon exists then it will run this function
  if (dataProfileElement) {
    // Saturation: This is a percentage value; 0% means a shade of gray and 100% is the full color.
    const content = dataProfileElement.textContent;
    const profileJson = JSON.parse(content);
    const profileName = profileJson.profile;

    const s = 50;
    // Lightness: This is also a percentage; 0% is black, 100% is white.
    const l = 80;
    let str = profileName.split(' ');
    str = str[0] + ' ' + str[str.length - 1];
    let hash = 0;
    // Creates a unique enough code from the name
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Hue: This is a degree on the color wheel from 0 to 360. 0 is red, 120 is green, 240 is blue.
    const h = hash % 360;
    const hexColor = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    const textColor = 'hsl(' + h + ', ' + 100 + '%, ' + 30 + '%)';
    const colorCircle = document.getElementById('profile-icon');
    colorCircle.style.background = hexColor;

    document.getElementById('profile-icon').innerHTML = str
      .split(' ')
      .map((name) => name[0])
      .join('')
      .toUpperCase();
    document.getElementById('profile-icon').style.color = textColor;
  }
});

window.submitAndDisable = function (button, form_id) {
  /**
   *  Function to prevent duplicate form submissions by only
   *  allowing the user to click the submit button once. This
   *  function is called by the onclick of form submit buttons.
   *
   *  @param button: Submit button element (passed as "this")
   *  @param form_id: ID of the form to validate and submit
   */
  const form = document.getElementById(form_id);
  // Since JS manually submits the form, by default it skips browser-based clientside validation.
  if (!form.checkValidity()) {
    form.reportValidity();
  } else {
    button.disabled = true;
    form.submit();
  }
};

window.set_sort_and_submit = function (sort_direction, sort_by) {
  /*
   * Function called by buttons in column_sorter.html to set the values of
   * hidden sort fields on a sortable form. Then at the end, send a custom
   * event through HTMX to trigger the form submission.
   *
   *  @param sort_direction: Sort direction ('asc', 'desc', or 'none')
   *  @param sort_by: The value (column name) to write to the sort fields
   */

  const sort_desc = document.getElementById('id_sort_desc');
  const sort_asc = document.getElementById('id_sort_asc');

  // Sort ascending button clicked
  if (sort_direction === 'asc') {
    sort_asc.value = sort_by;
    sort_desc.value = '';

    // Sort descending button clicked
  } else if (sort_direction === 'desc') {
    sort_asc.value = '';
    sort_desc.value = sort_by;

    // The active sort's button was clicked so toggle off the current sort.
  } else if (sort_direction === 'none') {
    sort_asc.value = '';
    sort_desc.value = '';
  }

  htmx.trigger(document.body, 'sort-changed');
};

function refreshPageAlert() {
  const refreshPageMessage = `This page may be out of date. You've had this page open for a while,
so some information may have changed. Please refresh the page to make sure you're viewing the latest data.`;

  alert(refreshPageMessage);
}
const twoHours = 1000 * 60 * 60 * 2;
setTimeout(refreshPageAlert, twoHours);
